<section class="loan_form" fxLayout="column" fxLayoutGap="30px">
  <bb-current-status></bb-current-status>
  <bb-loan-info></bb-loan-info>
  <bb-terms-and-conditions-field></bb-terms-and-conditions-field>
  <div fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="24px">
    <button class="submit" mat-raised-button fxFlexAlign="center"
            [disabled]="posting|async"
            (click)="sendLoanApplication()">
      Submit <i class="fa fa-spinner fa-spin" *ngIf="posting|async"></i>
    </button>
    <button mat-raised-button color="primary" fxFlexAlign="center"
            (click)="backward()">
      <i class="fa fa-caret-left"></i> Previous
    </button>

    <div class="subtle" fxLayoutAlign="center">* Required fields</div>
  </div>
</section>
